import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({
    selector: 'form-group',
    templateUrl: './form-group.component.html',
    styleUrls: ['./form-group.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FormGroupComponent {

  @HostBinding('class.in-focus')
  inFocus: boolean | undefined;

  setFocused(state: boolean) {
    this.inFocus = state || undefined;
  }

}
